import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { Hero } from './components/Hero';
// Below-the-fold sections are code-split so the initial load only ships/renders
// the Hero. Each chunk is fetched on demand, dramatically lowering the JS that
// must be parsed and executed before the page becomes interactive.
const SocialProof = lazy(() => import('./components/SocialProof').then(m => ({
  default: m.SocialProof
})));
const PainSection = lazy(() => import('./components/PainSection').then(m => ({
  default: m.PainSection
})));
const ProductHero = lazy(() => import('./components/ProductHero').then(m => ({
  default: m.ProductHero
})));
const TomosGrid = lazy(() => import('./components/TomosGrid').then(m => ({
  default: m.TomosGrid
})));
const BonosSection = lazy(() => import('./components/BonosSection').then(m => ({
  default: m.BonosSection
})));
const Pricing = lazy(() => import('./components/Pricing').then(m => ({
  default: m.Pricing
})));
const OrderBump = lazy(() => import('./components/OrderBump').then(m => ({
  default: m.OrderBump
})));
const Comparison = lazy(() => import('./components/Comparison').then(m => ({
  default: m.Comparison
})));
const ExtendedTestimonials = lazy(() => import('./components/ExtendedTestimonials').then(m => ({
  default: m.ExtendedTestimonials
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const PurchasePopup = lazy(() => import('./components/PurchasePopup').then(m => ({
  default: m.PurchasePopup
})));
const FB_PIXEL_ID = '1545009850674181';
// Lightweight placeholder that reserves vertical space to minimise layout shift
// while a lazy section streams in.
function SectionFallback() {
  return <div className="w-full min-h-[40vh]" aria-hidden="true" data-id="element-0" />;
}
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const w = window as any;
    if (w.fbq) return;
    try {
      // Define the fbq stub + queue so calls work even before the script loads
      const n: any = w.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      // Inject the external script defensively (head append, swallow load errors)
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      script.onerror = () => {
        /* cross-origin / blocked load — ignore so the app never crashes */
      };
      (document.head || document.documentElement).appendChild(script);
      w.fbq('init', FB_PIXEL_ID);
      w.fbq('track', 'PageView');
    } catch {
      /* never let analytics break the page */
    }
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-[#84CC16] selection:text-white" data-id="element-1">
      <Hero data-id="element-2" />
      <Suspense fallback={<SectionFallback data-id="element-4" />} data-id="element-3">
        <SocialProof data-id="element-5" />
        <PainSection data-id="element-6" />
        <ProductHero data-id="element-7" />
        <TomosGrid data-id="element-8" />
        <BonosSection data-id="element-9" />
        <Pricing data-id="element-10" />
        <OrderBump data-id="element-11" />
        <Comparison data-id="element-12" />
        <ExtendedTestimonials data-id="element-13" />
        <Guarantee data-id="element-14" />
        <FAQ data-id="element-15" />
        <FinalCTA data-id="element-16" />
        <Footer data-id="element-17" />
        <PurchasePopup data-id="element-18" />
      </Suspense>
    </div>;
}